import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GenerateCvService {
  mainURL = 'api/';
  userId = localStorage.getItem('userInfoz');
  constructor(private http: HttpClient) {}

  private cvDataSubject = new BehaviorSubject<any>(null);
  data$ = this.cvDataSubject.asObservable();

  setData(data: any) {
    this.cvDataSubject.next(data);
    if (data) {
      if (data['serviceSystemId']) {
        localStorage.setItem('serviceSystemId', data['serviceSystemId']);
        // console.log(data['cvImagePath']);
      }
    }
  }

  getData() {
    return this.cvDataSubject.value;
  }

  sentCvJsonData(data: any, cvType = 'first-template') {
    console.log('data is', data);
    return this.http.post(
      environment.apiUrl + this.mainURL + 'generate-cv-cl',
      data
    );
  }

  // Edit existing CV
  editCv(cvId: string, data: any) {
    return this.http.put(
      `${environment.apiUrl}${this.mainURL}generate-cv-cl/${cvId}`,
      data
    );
  }

  createCoverLetter(userId: string, data: any) {
    return this.http.post(
      environment.apiUrl + this.mainURL + userId + '/generate-cl',
      data
    );
  }

  uploadExistingCv(cv: FormData) {
    return this.http.post(
      environment.apiUrl + this.mainURL + 'upload-existing-cv',
      cv
    );
  }

enhanceLinkedinCv(data: any) {
  return this.http.post(
    environment.apiUrl + this.mainURL + 'enhance-linkedin',
    data,
    { responseType: 'blob', observe: 'response' }  // 
  );
}
downloadLinkedinProfile(serviceSystemId: string) {
  return this.http.get(
    `${environment.apiUrl}api/linkedin/download/${serviceSystemId}`
  );
}
  // Download cover letter PDF
  downloadCoverLetter(serviceSystemId: string) {
    return this.http.get(
      `${environment.apiUrl}api/coverletter/download/${serviceSystemId}`
    );
  }

  // Get cover letter status
  getCoverLetterStatus(serviceSystemId: string) {
    return this.http.get(
      `${environment.apiUrl}api/coverletter/status/${serviceSystemId}`
    );
  }
}
